var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3725_1005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9822 52.7775C25.0235 55.6952 30.9539 56.6799 36.6676 55.5481C42.3814 54.4162 47.4885 51.2451 51.0369 46.6258C54.5852 42.0066 56.3326 36.2546 55.9531 30.4422C55.5737 24.6298 53.0934 19.1537 48.9747 15.035C44.8559 10.9162 39.3799 8.43592 33.5675 8.0565C27.7551 7.67707 22.003 9.42442 17.3838 12.9728C12.7646 16.5211 9.5934 21.6282 8.46156 27.342C7.32973 33.0557 8.31446 38.9861 11.2322 44.0275L8.10468 53.365C7.98716 53.7173 7.9701 54.0955 8.05542 54.457C8.14074 54.8186 8.32507 55.1492 8.58774 55.4119C8.85041 55.6746 9.18104 55.8589 9.54258 55.9442C9.90413 56.0295 10.2823 56.0125 10.6347 55.895L19.9822 52.7775Z",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 33L29 39L41 27",
    stroke: "#FFE500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3725_1005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert4);
export default __webpack_public_path__ + "static/media/Alert4.78a0762ca2177465158f003e7900ee3f.svg";
export { ForwardRef as ReactComponent };